// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum EmailSendStatus {
  Success = 0,
  Failed = 1,
  UserNotFound = 2,
  InvalidObject = 3,
  Unknown = 4,
}
